import { request } from "./client";

export const createCheckoutSession = async ({ planId, billingCycle }) => {
  return request("/subscriptions/checkout-session", {
    method: "POST",
    body: JSON.stringify({ planId, billingCycle }),
  });
};

export const activateFreePlan = async () => {
  return request("/subscriptions/free", { method: "POST" });
};

export const fetchMySubscription = async () => {
  return request("/subscriptions/me");
};

export const devSwitchPlan = async ({ planId, billingCycle }) => {
  return request("/subscriptions/dev-switch-plan", {
    method: "POST",
    body: JSON.stringify({ planId, billingCycle }),
  });
};

export const verifyCheckoutSession = async (sessionId) => {
  return request(`/subscriptions/verify-session?sessionId=${encodeURIComponent(sessionId)}`);
};
